import { Box, Paper, PaperProps, Stack, Typography } from '@mui/material';
import { ReactNode } from 'react';

interface WorkspaceSettingsItemProps {
  icon: JSX.Element;
  title: string;
  titleAction?: JSX.Element;
  secondaryNode?: ReactNode;
  children: ReactNode;
  paperProps?: PaperProps;
}

export const WorkspaceSettingsItem = ({
  icon,
  title,
  titleAction,
  secondaryNode,
  children,
  paperProps,
}: WorkspaceSettingsItemProps) => {
  return (
    <Stack spacing={2}>
      <Stack direction="row" alignItems="center" spacing={1}>
        <Box>{icon}</Box>
        <Stack direction="row" alignItems="center" spacing={3}>
          <Typography variant="h6">{title}</Typography>
          <Box>{titleAction}</Box>
        </Stack>
      </Stack>
      {secondaryNode}
      <Paper
        variant="outlined"
        {...paperProps}
        sx={{
          borderRadius: 2,
          p: 3,
          ...paperProps?.sx,
        }}
      >
        {children}
      </Paper>
    </Stack>
  );
};
